import { User, UserOrganization, UserRole } from "../../__generated__/graphql";
import { ApolloError } from "@apollo/client";
import { PartialOrganization } from "./types";
import { createContext } from "react";

interface UserContextType {
  userRole: UserRole | null;
  organizations: PartialOrganization[] | null;
  currentOrganization: PartialOrganization | null;
  setCurrentOrganization: (organization: PartialOrganization) => void;
  isPartOfOrganization: boolean | null;
  isUserContextLoading: boolean;
  error: ApolloError | null;
  userOrganization: UserOrganization | null;
  userInfos: User | null;
}

export const UserContext = createContext<UserContextType>({
  organizations: null,
  currentOrganization: null,
  setCurrentOrganization: () => {},
  userRole: null,
  isPartOfOrganization: null,
  isUserContextLoading: false,
  error: null,
  userOrganization: null,
  userInfos: null,
});
